import { awsPartitionFromUse } from "@p0security/shared/integrations/resources/aws/gov-cloud";
import { existingIamWriteItems } from "@p0security/shared/integrations/resources/aws/install-options";
import {
  rdsSecurityPerimeterInstallCommands,
  rdsSecurityPerimeterTerraform,
} from "@p0security/shared/integrations/resources/aws/policy/rds-security-perimeter";
import Link from "antd/lib/typography/Link";

import { AwsInstaller } from "../types";

const rdsSecurityPerimeterInstructions: AwsInstaller["rds-security-perimeter"]["instructions"] =
  (context, id, item) => {
    const { vpcId, subnetIds, region, accountId } = item;
    const awsPartition = awsPartitionFromUse(
      context.config,
      id,
      "rds-security-perimeter"
    );
    const subnetIdsArray = subnetIds.split(",").map((s) => s.trim());
    return {
      help: (
        <>
          To install P0 on this account, provision P0&apos;s access using{" "}
          <Link
            href={`https://${id}.signin.aws.amazon.com/console`}
            target="_blank"
            rel="noopener"
          >
            AWS Cloud Shell
          </Link>{" "}
          or Terraform:
        </>
      ),
      commands: {
        // TODO: Add IAC commands
        shell: [
          {
            command: rdsSecurityPerimeterInstallCommands(context, {
              awsPartition,
              gcloudServiceAccountId: context.config.base[id]?.serviceAccountId,
              awsAccountId: accountId,
              options: { vpcId, region },
              subnetIds: subnetIdsArray,
            }),
          },
        ],
        iac: [
          {
            command: rdsSecurityPerimeterTerraform(context, {
              awsPartition,
              gcloudServiceAccountId: context.config.base[id]?.serviceAccountId,
              awsAccountId: accountId,
              options: { vpcId, region },
              subnetIds: subnetIdsArray,
            }),
          },
        ],
      },
    };
  };

export const rdsSecurityPerimeterInstaller: AwsInstaller["rds-security-perimeter"] =
  {
    items: {
      accountId: {
        optionProvider: async ({ config }) => {
          return existingIamWriteItems(config).map(([id, item]) => ({
            id,
            label: item?.label,
          }));
        },
      },
    },
    instructions: rdsSecurityPerimeterInstructions,
  };
